module.exports = __webpack_public_path__ + "img/img_01.2aa6c565.jpg";